import {GeographicLabels} from '../lib/geographic-labels.js';
import {is3DView} from '../lib/camera-state.js';
import {state as stationsState} from './stations.js';
import {isInterpolationEnabled} from './interpol.js';
import {isRadarEnabled,getRadarLabelFrame} from './radar.js';
import {createRadarLabelSampler,radarCoveredPlaces} from '../lib/radar-label-mask.js';

export function referenceVisibility(interpolation,stationsVisible,terrain,radar=false){
 const enabled=Boolean(radar||(interpolation&&!stationsVisible));
 return {enabled,terrain:Boolean(interpolation&&!stationsVisible&&terrain)};
}
export function initGeographicReferences(map){
 const labels=new GeographicLabels(map,{peaksUrl:'/v2/assets/data/relief-peaks.json'}),readMask=createRadarLabelSampler();
 let ready=false,loading=null,removed=false,syncing=false,places=[],subsetKey='',requestedKey='',generation=0,townMinZoom=8;
 const state=()=>referenceVisibility(isInterpolationEnabled(),stationsState.options.visible,is3DView(map),isRadarEnabled());
 function setSubset(key,subset){if(key!==subsetKey){subsetKey=key;labels.setPlaces(subset);}}
 function sync(){
  if(removed||syncing)return;
  const wanted=state();
  if(ready){
   syncing=true;
   try{
    const satellite=map.getLayoutProperty('base-esri','visibility')==='visible';
    const interpolated=isInterpolationEnabled()&&!stationsState.options.visible;
    if(isRadarEnabled()&&!satellite&&!interpolated){
     const frame=getRadarLabelFrame(),key=frame?.key||'no-radar-frame';
     if(key!==requestedKey){
      requestedKey=key;const request=++generation;
      if(!frame)setSubset(key,[]);
      else readMask(frame).then(mask=>{
       if(removed||generation!==request)return;
       setSubset(key,radarCoveredPlaces(places,frame,mask));sync();
      });
     }
    }else{
     if(requestedKey!=='all'){requestedKey='all';generation++;}
     setSubset('all',places);
    }
    labels.update(wanted);
    // A phone fits Sicily below zoom 8: retain a few collision-managed town
    // names there too, rather than only the provincial capitals.
    const minzoom=isRadarEnabled()?6:8;
    if(map.getLayer('forecast-town-names')&&townMinZoom!==minzoom){townMinZoom=minzoom;map.setLayerZoomRange('forecast-town-names',minzoom,24);}
    for(const id of ['forecast-capital-names','forecast-town-names','forecast-locality-names'])if(map.getLayer(id)){
     const opacity=isRadarEnabled()?.85:1,halo=isRadarEnabled()?1.2:2;
     if(map.getPaintProperty(id,'text-opacity')!==opacity)map.setPaintProperty(id,'text-opacity',opacity);
     if(map.getPaintProperty(id,'text-halo-width')!==halo)map.setPaintProperty(id,'text-halo-width',halo);
    }
   }finally{syncing=false;}
   return;
  }
  if(!wanted.enabled||loading)return;
  loading=fetch('/v2/assets/data/geographic-places.json').then(r=>{if(!r.ok)throw Error('Località non disponibili');return r.json();}).then(data=>{
   if(removed)return;
   places=data;
   if(!map.getStyle().glyphs)map.setGlyphs('https://tiles.openfreemap.org/fonts/{fontstack}/{range}.pbf');
   labels.setPlaces([]);ready=true;sync();
  }).catch(error=>{loading=null;if(!removed)console.warn('Riferimenti geografici:',error.message);});
 }
 const events=['wsv2:interpolation-change','wsv2:stations-visible','wsv2:viewchange','wsv2:radar-visibility','wsv2:radar-frame'];
 const changedControl=event=>{if(['chkMarkers','chkInterpol'].includes(event.target?.id))sync();};
 document.addEventListener('change',changedControl);
 for(const event of events)document.addEventListener(event,sync);
 map.on('styledata',sync);
 map.on('remove',()=>{removed=true;generation++;readMask.clear();for(const event of events)document.removeEventListener(event,sync);document.removeEventListener('change',changedControl);map.off('styledata',sync);});
 sync();return {sync};
}
